import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {AgencyTokenObj} from 'src/app/features/agency-token-api/AgencyTokenObj';

@Injectable({
  providedIn: 'root'
})
export class AgencyTokenAPIService extends DataService {

  private baseURI = this.apiUri + '/organizationAPI/';

  constructor(http: HttpClient) {
    super(http);
  }

  /*
  Function to get generate Token by a organizationId
   */
  getgeneratedToken(organizationId: any): Observable<any> {
    const tokenUrl = this.baseURI + 'randomToken/' + organizationId + '/organizationId';
    this.setUri(tokenUrl);
    console.log(this.get());
    return this.get();
  }

  saveOragnizationApi(agencyTokenApi: AgencyTokenObj): Observable<any> {
    this.setUri(this.baseURI + 'save');
    return this.update(agencyTokenApi);
  }

  getOrganization(organizationId: any): Observable<any> {
    const tokenUrl = this.baseURI + 'getOrganizationAPI/' + organizationId + '/organizationId';
    this.setUri(tokenUrl);
    return this.get();
  }

}
